import React from "react";
import Main from "../Structure/Main";
import Ep from "../Structure/Ep";
import Animeover from "../Structure/Animeover";
import Footer from "../components/Footer";

export default function Mash() {
  return (
    <>
      <Main
        img="https://a.storyblok.com/f/178900/849x1200/3ea3addb7a/mashle-s2-kv.jpeg/m/filters:quality(95)format(webp)"
        name="Mashle : Magic and Muscles "
        s="2"
        e="12"
      />

      <Ep ep="S1-E1 Mashle : Magic and Muscles" s="S1-E1" />
      <Ep ep="S1-E2 Mashle : Magic and Muscles" s="S1-E2" />
      <Ep ep="S1-E3 Mashle : Magic and Muscles" s="S1-E3" />
      <Ep ep="S1-E4 Mashle : Magic and Muscles" s="S1-E4" />
      <Ep ep="S1-E5 Mashle : Magic and Muscles" s="S1-E5" />
      <Ep ep="S1-E6 Mashle : Magic and Muscles" s="S1-E6" />
      <Ep ep="S1-E7 Mashle : Magic and Muscles" s="S1-E7" />
      <Ep ep="S1-E8 Mashle : Magic and Muscles" s="S1-E8" />
      <Ep ep="S1-E9 Mashle : Magic and Muscles" s="S1-E9" />
      <Ep ep="S1-E10 Mashle : Magic and Muscles" s="S1-E10" />
      <Ep ep="S1-E11 Mashle : Magic and Muscles" s="S1-E11" />
      <Ep ep="S1-E12 Mashle : Magic and Muscles" s="S1-E12" />
      <Animeover />
      <Footer />
    </>
  );
}
